import { useContext } from 'react';
import { SuprSendFeedContext } from '../context/SuprSendFeedProvider';

function useFeedClient() {
  const context = useContext(SuprSendFeedContext);

  if (!context) {
    throw new Error(
      'useFeedClient must be used within a SuprSendProvider and SuprSendFeedProvider'
    );
  }

  return context.feedClient;
}

export default useFeedClient;
